const FJTextToImageConstant = {
    AI_OPTIMIZING: 'AI_OPTIMIZING', // 文生图提示词AI优化中
    IMAGE_IMPORTING: 'IMAGE_IMPORTING', // 文生图提示词图片导入中
    NORMAL: 'NORMAL', // 文生图提示词常规输入模式
};

export default FJTextToImageConstant;
